import React from 'react';
import { Card, CardContent, Stack, SvgIcon, Typography } from '@mui/material';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import Client from '../Client';
import { salesSummary } from './simpleBiReportsApi';

function thousandsSeparator(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

class OverviewMonthSales extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      client: new Client("none"),
      sales_total: [],
      filterData: {}
    };

    this.getData = this.getData.bind(this);
    this.doSync = this.doSync.bind(this);
  }

  componentDidMount() {
    this.getData();
  }

  componentDidUpdate(prevProps) {
    if (String(prevProps.location) !== String(this.props.location)) {
      this.getData();
    }
  }

  getData() {
    let queryData = {
      location: this.props.location ?? 0
    };
    let data = salesSummary(this.state.client, queryData);

    if (data) {
      this.setState({ sales_total: data });
    }

    this.setState({ filterData: queryData });
  }

  doSync() {
    this.getData();
  }

  formatAmount(value) {
    const numberValue = parseInt(value || 0);

    if (numberValue > 1000000) {
      return thousandsSeparator((numberValue / 1000000).toFixed(2)) + " M";
    }

    return thousandsSeparator(numberValue.toFixed(0));
  }

  render() {
    let salesTYV = 0;
    let salesLYV = 0;
    let salesTodayTY = 0;
    let salesTodayLY = 0;
    let diff_salesV = 0;
    let diff_posV = false;

    if (this.state.sales_total) {
      let sales_total = this.state.sales_total;

      if (sales_total.sales_TY !== undefined) salesTYV = parseInt(sales_total.sales_TM);
      if (sales_total.sales_LY !== undefined) salesLYV = parseInt(sales_total.sales_TMLY);
      if (sales_total.sales_Today !== undefined) salesTodayTY = parseInt(sales_total.sales_Today);
      if (sales_total.sales_TodayLY !== undefined) salesTodayLY = parseInt(sales_total.sales_TodayLY);

      if ((salesLYV - salesTodayLY) > 0) {
        diff_salesV = parseFloat(((salesTYV - salesTodayTY) / (salesLYV - salesTodayLY) - 1) * 100).toFixed(1);
      }

      diff_posV = diff_salesV >= 0;
    }

    return (
      <Card
        sx={{
          background: "#f6f4ef",
          overflow: 'hidden',
          position: 'relative',
          borderRadius: "14px",
          height: '100%'
        }}
      >
        <CardContent
          sx={{
            p: {
              xs: 1.2,
              sm: 1.5
            },
            "&:last-child": {
              pb: {
                xs: 1.2,
                sm: 1.5
              }
            },
            minHeight: {
              xs: 112,
              sm: 116,
              md: 112
            },
            display: "flex",
            flexDirection: "column",
            justifyContent: "center"
          }}
        >
          <Stack
            alignItems="center"
            justifyContent="center"
            spacing={1}
          >
            <Typography
              color="#1a237e"
              align="center"
              sx={{
                lineHeight: 1.2,
                fontSize: {
                  xs: "11px",
                  sm: "12px"
                },
                fontWeight: 800,
                letterSpacing: "0.5px",
                textTransform: "uppercase"
              }}
            >
              Sales This Month
            </Typography>

            <Typography
              align="center"
              sx={{
                color: "#1e2833",
                fontWeight: 600,
                fontSize: {
                  xs: "28px",
                  sm: "28px",
                  md: "32px"
                },
                lineHeight: 1.1
              }}
            >
              {this.formatAmount(salesTYV)}
            </Typography>
          </Stack>

          <Stack
            alignItems="center"
            justifyContent="center"
            direction="row"
            spacing={1}
            sx={{ mt: 1.25 }}
          >
            <SvgIcon
              color={diff_posV ? 'success' : 'error'}
              fontSize="small"
            >
              {diff_posV ? <ArrowUpwardIcon /> : <ArrowDownwardIcon />}
            </SvgIcon>

            <Typography
              color={diff_posV ? 'success.main' : 'error.main'}
              sx={{
                fontSize: {
                  xs: "14px",
                  sm: "16px"
                },
                fontWeight: 400,
                lineHeight: 1
              }}
            >
              {diff_salesV}%
            </Typography>

            <Typography
              color="text.secondary"
              sx={{
                fontSize: {
                  xs: "11px",
                  sm: "12px"
                },
                lineHeight: 1
              }}
            >
              vs. LY
            </Typography>
          </Stack>
        </CardContent>
      </Card>
    );
  }
}

export default OverviewMonthSales;
